import * as actions from './slice'

export const getToolPathwayContent = {
  eventName: 'getToolPathwayContent',
  onSuccess: [{ redux: true, action: actions.setToolPathwayContent }]
}
